import { EarningReportItemData } from "@scrile/api-provider/dist/api/TransactionProvider";
import { EarningReportData, EarningReportTypeStatDetails, StatField } from "@/views/PageStatements/types";

export const getEarningReportTypeStatDetails = (): EarningReportTypeStatDetails => ({
  totalAmount: 0,
  fee: 0,
  amount: 0,
  agentFee: 0,
});

export const getEmptyEarningReportTypeStats = (fields: StatField[]): EarningReportData["typeStats"] =>
  fields.reduce<EarningReportData["typeStats"]>(
    (out, field) => {
      out[field.key] = getEarningReportTypeStatDetails();
      return out;
    },
    { other: getEarningReportTypeStatDetails() }
  );

export const getStatType = (stat: EarningReportItemData, fields: StatField[]) =>
  fields.find(field => field.selector(stat))?.key ?? "";
